

// STOREFRONT CUSTOM JS

/**
 * ShopifyStorefrontClient
 */

// Configuration constants
const SHOPIFY_DOMAIN = "https://new-garciacarrion-emp.myshopify.com";
const STOREFRONT_TOKEN = "62e7fa9f879855c86dd67dc6a1e98cb0";
const API_VERSION = "2025-07";

// Shopify Storefront Client
class ShopifyStorefrontClient {
  constructor() {
    this.apiUrl = `${SHOPIFY_DOMAIN}/api/${API_VERSION}/graphql.json`;
  }

  /**
   * Execute a GraphQL query or mutation against the Storefront API.
   * @param {string} query - GraphQL query string
   * @param {object} variables - Variables for the query
   * @returns {Promise<object>} - Parsed JSON response
   */
  async request(query, variables = {}) {
    const response = await fetch(this.apiUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Shopify-Storefront-Access-Token": STOREFRONT_TOKEN,
      },
      body: JSON.stringify({ query, variables }),
    });

    const json = await response.json();

    if (json.errors) {
      console.error("GraphQL errors:", json.errors);
      throw new Error(JSON.stringify(json.errors));
    }

    return json.data;
  }

  // CUSTOMER RECOVER: Send password recovery email

  /**
   * Sends a password recovery email to the customer.
   * @param {string} email - Customer email
   * @returns {Promise<object>}
   */
  async customerRecover(email) {
    const query = `
      mutation customerRecover($email: String!) {
        customerRecover(email: $email) {
          customerUserErrors {
            code
            field
            message
          }
        }
      }
    `;
    return await this.request(query, { email });
  }

  // CUSTOMER RESET: Reset password using token

  /**
   * Resets the customer's password using the token from the recovery email.
   * @param {string} passwordResetToken - Token from the recovery email link
   * @param {string} email - Customer email
   * @param {string} newPassword - New password
   * @returns {Promise<object>}
   */
  async customerReset(passwordResetToken, email, newPassword) {
    const query = `
      mutation customerReset($passwordResetToken: String!, $email: String!, $password: String!) {
        customerReset(passwordResetToken: $passwordResetToken, email: $email, password: $password) {
          customer {
            id
            email
            firstName
            lastName
          }
          customerAccessToken {
            accessToken
            expiresAt
          }
          customerUserErrors {
            code
            field
            message
          }
        }
      }
    `;

    const variables = { passwordResetToken, email, password: newPassword };
    return await this.request(query, variables);
  }
}